import Uint8Array from './_Uint8Array';

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

export default cloneArrayBuffer;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_cloneArrayBuffer.js
// module id = null
// module chunks = 